import InfiniteScroller from './InfiniteScroller.component';
export default InfiniteScroller;